<template>
    <DefaultLayout>
        <div>
            <h1>Posts Guardados</h1>
            <div class="spacer" />
            <form class="search-form">
                <v-icon name="fa-filter"></v-icon>
                <input type="text" v-model="search" placeholder="Escribe aquí para filtrar." @keyup="handleSearch"
                    class="input-job" />
            </form>
            <div class="spacer" />
            <div class="table-container">
                <table class="modern-table">
                    <thead>
                        <tr>
                            <th>Imagen</th>
                            <th>Título</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <div v-if="loading">
                        <v-icon name="ri-loader-2-fill" animation="spin" class="icon" />
                    </div>
                    <tbody v-else>
                        <tr v-for="item in filtered" :key="item.codepost.id">
                            <td> <img :src="item.codepost.image_uri" width="100" /></td>
                            <td> {{ item.codepost.title }} </td>
                            <td>
                                <v-icon name="md-fileopen-round" class="ver" :fill="main.SECONDARY_COLOR" scale="2"
                                    @click="readMore(item.codepost.id)"></v-icon>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </DefaultLayout>
</template>

<script lang="ts" setup>
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import ChannelService from '@/services/ChannelService'
import { onMounted, ref , Ref} from 'vue';
import { useAuth } from '@/store/useAuth'
import router from '@/router'
import main from '@/data/main.js';
import CodeI from '@/interfaces/CodeBiteInterface';


const service = new ChannelService()
const items:Ref<CodeI[]> = ref([])
const filtered:Ref<CodeI[]> = ref([])
const loading = ref(false)
const search = ref('')
const store = useAuth()

onMounted(async () => {
    if (!store.token) { return }
    loading.value = true
    items.value = await service.GetSavedCodePosts(store.token)
    filtered.value = items.value
    loading.value = false
})

const readMore = (id: string | undefined) => {
    router.push({ name: 'codepost-view', params: { id: id } })
}

const handleSearch = () => {
    loading.value = true
    filtered.value = items.value.filter(item => item.codepost?.title?.toLowerCase().includes(search.value.toLowerCase()))
    loading.value = false
}
</script>

<style lang="scss" scoped>
.ver {
    margin-left: 5px;
    margin-right: 5px;
    cursor: pointer;
}

.employ-card {
    width: 100%;
    padding: 20px;
    border-radius: 10px;
    background-color: $secondary-color;
    color: white;
    margin-top: 5px;
    margin-bottom: 5px;
    display: flex;
    justify-content: space-around;
    align-items: center;
}


.btn {
    text-decoration: none;
    margin-left: 20px;
}

.input-job {
    width: 100vw;
}

/* Estilos para la tabla */
.modern-table {
    width: 100%;
    border-collapse: collapse;

}

.modern-table th,
.modern-table td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

th {
    color: $secondary-color !important;
}

.modern-table th:first-child,
.modern-table td:first-child {
    padding-left: 20px;
}

.table-container {
    overflow-x: auto;
}

.modern-table th:last-child,
.modern-table td:last-child {
    padding-right: 20px;
}

/* Estilos para el hover */
.modern-table tbody tr:hover {
    background-color: #f5f5f5;
    transition: background-color 0.3s ease;
}

.modern-table tbody tr:hover td {
    color: #333;
}

.modern-table tbody tr:hover a {
    color: $third-color;
    transition: color 0.3s ease;
}</style>